import { ElementState } from "@creatomate/preview";
import { ElementSource } from "chq";

const deleteSections = (
  allSubtitleElements: ElementState[],
  element: ElementState
): ElementSource[] => (
  allSubtitleElements.filter(subtitleElement => {
    const [_prefix, refId] = subtitleElement.source.name.split("REF=", 2);
    return refId !== element.source.id;
  }).map(subtitleElement => (subtitleElement.source))
);

export default deleteSections;
